import { Component } from 'san';
import { ELight } from 'src/enums';
import { IProjectFilterItem } from 'src/models';
import Light from '../Light/Light';

export default class ProjectFilterLight extends Component {
    constructor(options: any) {
        super(options);
    }

    static computed = {
        checkedItems() {
            const items = this.data.get('items');
            return _.filter(items, { is_checked: true })
        }
    }

    static components = {
        'ui-light': Light
    }

    initData(): any {
        return {
            key: '',
            title: '',
            items: [],
            isMultiple: false,
            lightEnum: ELight
        };
    }

    inited() {
    }

    toggleCheck(item: IProjectFilterItem) {
        const items: IProjectFilterItem[] = this.data.get('items');
        const index: number = _.findIndex(items, { value: item.value });
        items[index].is_checked = !items[index].is_checked;
        // 单选
        if (!this.data.get('isMultiple')) {
            for (let i = 0; i < items.length; i++) {
                if (i !== index) {
                    items[i].is_checked = false;
                }
            }
        }

        this.dispatch('UI:project-filter-changed', {
            key: this.data.get('key'),
            items
        });
    }

    clear() {
        const items: IProjectFilterItem[] = this.data.get('items');
        _.forEach(items, item => {
            item.is_checked = false;
        });
        this.dispatch('UI:project-filter-changed', {
            key: this.data.get('key'),
            items
        });
    }

    lightKey2lightValue(key: string): number {
        switch (key) {
            case 'red':
                return ELight.Red;
            case 'green':
                return ELight.Green;
            case 'yellow':
                return ELight.Yellow;
            case 'no-color':
            default:
                return ELight.None;
        }
    }

}